import { X } from '@phosphor-icons/react';

// Reusable confirmation modal (light theme, matches dashboard modals)
export function ConfirmModal({
  open,
  title,
  children,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = false,
  processing = false,
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-50 p-4 animate-in fade-in duration-150">
      <div className="bg-white rounded-2xl border border-[#E4E4E7] w-full max-w-md shadow-2xl overflow-hidden">
        <div className="p-6 border-b border-[#E4E4E7] flex items-center justify-between">
          <h3 className="font-bold text-[#09090B]">{title}</h3>
          <button onClick={onCancel} className="text-[#A1A1AA] hover:text-[#09090B]">
            <X size={20} />
          </button>
        </div>
        <div className="p-6">{children}</div>
        <div className="p-6 border-t border-[#E4E4E7] flex gap-3">
          <button
            onClick={onCancel}
            disabled={processing}
            className="flex-1 py-2.5 border border-[#E4E4E7] text-[#09090B] font-medium hover:bg-[#F4F4F5] disabled:opacity-50"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onConfirm}
            disabled={processing}
            data-testid="confirm-modal-confirm"
            className={`flex-1 py-2.5 text-white font-medium disabled:opacity-50 transition-colors ${
              danger ? 'bg-red-600 hover:bg-red-700' : 'bg-[#0047FF] hover:bg-[#0035CC]'
            }`}
          >
            {processing ? 'Procesando...' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
